import { type CrossService } from '@/infra/services/catalog/crosses/model';
import * as tracker from '@/infra/tracking/events';
import { useRunOnce } from '@/presenters/hooks/use-run-once';
import { useServiceState } from '@/presenters/store/catalog/service';

export default function useOptionalsAnalytics(optionals: CrossService[] = []) {
  const serviceId = useServiceState((state) => state.service._id);

  useRunOnce(() => {
    optionals.forEach((optional) => {
      tracker.pushViewItem({
        item: {
          id: optional.id,
          bindId: serviceId,
          name: optional.name,
          type: 'optional-service',
          price: optional.price.to,
          brand: 'Leroy Merlin',
          categoryTree: 'serviço',
          seller: 'Leroy Merlin',
          quantity: 1,
        },
      });
    });
  }, optionals.length > 0);

  return null;
}
